import React, { useContext } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import ProgressGrid from '../ProgressGrid/ProgressGrid.jsx';
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import { useLocation } from 'react-router-dom';
import AssessmentQuestionContext from '../../Store/AssessmentQuestionContext.jsx';

const ProgressBarSingle = (props) => {

  const totalNumOfQuestions = props?.totalNumOfQuestions;
  const sections = props?.sections;
  const currentSectionName = props?.currentSectionName;

  const { windowWidth } = useWindowDimensions();
  const assmentCtx = useContext(AssessmentQuestionContext);
  const threeWaytieBreakersPageIdArray = [955, 956, 957, 958]
  const twoWaytieBreakersPageIdArray = [949, 959, 966, 967, 968, 969, 970]
  const twoWaytieBreakersPageIdArrayRound2 = [985, 986, 987, 989, 990, 978]

  const threeWaytieBreakersPageIdArrayLeadership = [960, 961, 962, 963]
  const twoWaytieBreakersPageIdArrayLeadership = [965, 964, 971, 964, 972, 973, 974, 975]
  const twoWaytieBreakersPageIdArrayRound2Leadership = [984, 996, 997, 998, 999, 1000, 1001]

  const isStarter = twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId)) || props?.pageId == "866" || props?.pageId == "953";
  const isLeader = twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId)) || props?.pageId == "954" || props?.pageId == "947";
  const isMindSet = props?.pageId === "948" ? true : false;

  let location = useLocation()

  const getDisplayProgress = () => {

    // console.log("allQuestions assmentCtx",assmentCtx?.allQuestions)

    const pageIdArray = assmentCtx?.allQuestions?.flatMap((el) => el.pageId)
    const allQuestions = assmentCtx?.allQuestions?.flatMap((el) => {
      if (el?.pageId == "866" || el?.pageId == "953" || el?.pageId == "947" || el?.pageId == "954" || el?.pageId == "948") {
        return el?.data
      }
      return []
    });

    const getUnVisitedPagidQuestions = () => {
      if (!pageIdArray?.includes("953")) {
        return 72; // 953 = 20
      }
      else if (!pageIdArray?.includes("947")) {
        return 72 - 20; // 947 = 20
      }
      else if (!pageIdArray?.includes("954")) {
        return 72 - 20 - 20; // 954 = 20 & 947 = 20
      }
      else if (!pageIdArray?.includes("948")) {
        return 12;
      }

      return 0;
    }

    let totalQuestions = 92
    let currentQIndex = 0;

    for (let i in allQuestions) {
      if (allQuestions[i]?.id == props?.currentQuestion?.id) currentQIndex = i;
    }

    if (twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId))) {
      currentQIndex = 19;
    }
    else if (twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId))) {
      currentQIndex = 38;
    }
    else if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId))) {
      currentQIndex = 59;
    }
    else if (twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId))) {
      currentQIndex = 78;
    }


    let displayProgress = ((currentQIndex / totalQuestions) * 100) + 1;
    console.log("currentSecTotal(totalQuestions)-currentQIndex-allQuestions-displayProgress", totalQuestions, currentQIndex, allQuestions, displayProgress)

    return displayProgress;
  }

  const displayProgress = getDisplayProgress();

  const getProgress = (section_name) => {

    const allQuestions = assmentCtx?.allQuestions?.flatMap((el) => {
      if (el?.pageId == "866" || el?.pageId == "953" || el?.pageId == "947" || el?.pageId == "954" || el?.pageId == "948") {
        return el?.data
      }
      return []
    });

    const pageIdArray = assmentCtx?.allQuestions?.flatMap((el) => el.pageId)

    // finding the index of the last question here
    // and then that index will be used to determine the size of the
    // particular section

    const currentSectionQuestions = allQuestions?.filter((el) => getSectionWiseQuestion(el.pageId))
    let currentQidx = 0;

    for (let i in allQuestions) {
      if (allQuestions[i]?.id == props?.currentQuestion?.id) currentQidx = i;
    }

    let currentSecTotal = 92;

    if (twoWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArray?.includes(parseInt(props?.pageId))) {
      currentQidx = 19;
    }
    else if (twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId))) {
      currentQidx = 38;
    }
    else if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(props?.pageId))) {
      currentQidx = 59;
    }
    else if (twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(props?.pageId))) {
      currentQidx = 78;
    }

    let progress = ((currentQidx / currentSecTotal) * 100) + 1;
    console.log("currentSecTotal-currentQidx-allQuestions-progress", currentSecTotal, currentQidx, allQuestions, progress)

    // ANIMATION CONTROL LOGIC STARTS HERE

    console.log('props.activeStep', props.activeStep)

    if (props?.next && props?.isPauseScreen) {
      if (props?.pageId == "947" && section_name == "Leadership") return 42;
      if (props?.pageId == "948") return 87;
    }  
    if (props?.back && !props.isPauseScreen) {
      if (isStarter && (props?.pageId == "866" || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(props?.pageId))) && section_name == "Starter") { }
      else if (props?.pageId == "953") return 42;
      else if (props?.pageId == "954") return 86;
    }

    if (props?.next && !props.isPauseScreen) {
      if (isStarter && (props?.pageId == "953")) {
        if (props?.activeStep == 18) return 42;
        else return 23;
      }
      if (isLeader && (props?.pageId == "954")) {
        if (props?.activeStep >= 18) {
          return 86;
        }
        return 66;
      }
    }

    // ANIMATION CONTROL LOGIC ENDS HERE


    return progress;
  }

  const getSectionWiseQuestion = (page_id) => {
    if (isStarter && (twoWaytieBreakersPageIdArray?.includes(parseInt(page_id)) || threeWaytieBreakersPageIdArray?.includes(parseInt(page_id)) || twoWaytieBreakersPageIdArrayRound2?.includes(parseInt(page_id)) || page_id == 866 || page_id == 953)) {
      return true;
    }
    if (twoWaytieBreakersPageIdArrayLeadership?.includes(parseInt(page_id)) || threeWaytieBreakersPageIdArrayLeadership?.includes(parseInt(page_id)) || twoWaytieBreakersPageIdArrayRound2Leadership?.includes(parseInt(page_id)) || page_id == 947 || page_id == 954) {
      return true;
    }
    else if (page_id == "948") {
      return true;
    }
    else {
      return false
    }
  }

  const getDisplaySectionName = () => {
    if (props.isPauseScreen) {
      if (props.pageId == "947") return "STARTER/FLOW";
      if (props.pageId == "948") return "Leadership";
    }

    if (currentSectionName === "Starter") return "STARTER/FLOW";
    if (currentSectionName === "Mindset") return "Mindset";
    if (currentSectionName === "Leadership") return "Leadership";

    return currentSectionName;
  };



  let percentageColor = '#578494';
  let activeColor = '#578494';
  let passiveColor = '#29403F';
  // let sectionstyle         = { color: activeColor, fontWeight: '700' };

  let progress = getProgress(currentSectionName);
  console.log("progress-pageid-back-next-isPauseScreen-props?.activeStep", progress, props?.pageId, props.back, props.next, props?.isPauseScreen,props?.activeStep)

  console.log('currentSectionName', currentSectionName)
  console.log('isPauseScreen', props.isPauseScreen)

  return (
    <div>
      <div className="progress-bar" style={{ maxWidth: windowWidth < 830 ? "75%" : "100%" }}>
        <div className="bar-section" style={{ width: location?.pathname?.includes('/walkthrough') ? "20%" : "100%", margin: location?.pathname?.includes('/walkthrough') ? "0 auto" : null }}>
          <p className="progress-percentage" style={{ width: `${progress}%`, color: percentageColor }}><span>{`${Math.round(displayProgress)}%`}</span></p>
          <div className="bar"><LinearProgress className="custom-bar" variant="determinate" value={parseInt(progress)} /></div>
          {/* <ProgressGrid progress={progress} /> */}

          <div className="sections" style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
            <p style={{
              color: location?.pathname?.includes('/walkthrough') ? "#29403F" : activeColor, textTransform: "uppercase", textAlign: "center", fontSize: "18px", fontWeight: "700", lineHeight: "110.00000000000001%", letterSpacing: 0
            }} className="section-name">  {getDisplaySectionName()}</p>
            {/* {sections?.map((sec, idx) => {
              return <p key={idx} style={{
                color: currentSectionName?.toLowerCase().trim() === sec.section.toLowerCase().trim() ? activeColor : passiveColor, textTransform: "uppercase", textAlign: "center",
                // width: `${100/sections?.length}%` 
              }} className="section-name">{sec.section}</p>
            })} */}
          </div>

        </div>
      </div>

    </div>
  );
}
export default ProgressBarSingle;
